{
  "fields": {
    "email": "Adresse email",
    "password": "Mot de passe",
    "newPassword": "Nouveau mot de passe",
    "firstName": "Prénom",
    "lastName": "Nom",
    "name": "Nom affiché",
    "role": "Je suis"
  },
  "roles": {
    "student": "Élève",
    "teacher": "Enseignant"
  },
  "validation": {
    "required": "Ce champ est obligatoire.",
    "email": "Saisissez une adresse email valide.",
    "passwordHint": "Au moins {{count}} caractères. Une phrase entière vaut mieux qu'un mot compliqué.",
    "passwordTooShort": "Le mot de passe doit contenir au moins {{count}} caractères."
  },
  "violations": {
    "too_short": "Le mot de passe est trop court.",
    "too_long": "Le mot de passe est trop long.",
    "too_common": "Ce mot de passe figure dans des fuites de données connues.",
    "contains_personal_data": "Le mot de passe ne doit pas contenir votre nom ni votre adresse email.",
    "unknown": "Ce mot de passe ne respecte pas la politique de sécurité."
  },
  "login": {
    "heading": "Connexion",
    "submit": "Se connecter",
    "submitting": "Connexion…",
    "forgotPassword": "Mot de passe oublié ?",
    "noAccount": "Pas encore de compte ?",
    "registerLink": "Créer un compte"
  },
  "register": {
    "heading": "Créer un compte",
    "submit": "Créer mon compte",
    "submitting": "Création…",
    "haveAccount": "Vous avez déjà un compte ?",
    "loginLink": "Se connecter",
    "doneHeading": "Vérifiez votre adresse",
    "doneBody": "Un email de confirmation vient de vous être envoyé. Ouvrez le lien qu'il contient pour activer votre compte.",
    "goToLogin": "Aller à la connexion"
  },
  "verifyEmail": {
    "heading": "Confirmation de votre adresse",
    "pending": "Vérification en cours…",
    "success": "Votre adresse est confirmée. Vous pouvez vous connecter.",
    "missingToken": "Ce lien est incomplet. Utilisez celui reçu par email.",
    "expiredHelp": "Le lien a peut-être expiré. Demandez-en un nouveau depuis la page de connexion.",
    "goToLogin": "Aller à la connexion"
  },
  "forgotPassword": {
    "heading": "Mot de passe oublié",
    "intro": "Indiquez votre adresse email : si elle correspond à un compte, vous recevrez un lien de réinitialisation.",
    "submit": "Envoyer le lien",
    "submitting": "Envoi…",
    "sent": "Si cette adresse correspond à un compte, un email vient de partir. Pensez à regarder vos indésirables.",
    "backToLogin": "Retour à la connexion"
  },
  "resetPassword": {
    "heading": "Nouveau mot de passe",
    "submit": "Enregistrer",
    "submitting": "Enregistrement…",
    "success": "Mot de passe modifié. Toutes vos sessions ont été fermées : reconnectez-vous.",
    "missingToken": "Ce lien est incomplet. Utilisez celui reçu par email.",
    "goToLogin": "Aller à la connexion"
  },
  "session": {
    "restoring": "Restauration de votre session…"
  }
}
